import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/store/auth-store';
import { getAuthenticatedUser } from '@/api/user';
import type { AuthenticatedUser } from '@/types/user';

export const userKeys = {
  me: ['user', 'me'] as const,
};

export function useUserInfo() {
  const user = useAuthStore((state) => state.user);

  return useQuery<AuthenticatedUser>({
    queryKey: userKeys.me,
    queryFn: getAuthenticatedUser,
    enabled: !!user,
    staleTime: 60_000,
  });
}
